import { Theme, css } from '@emotion/react';

export const inputContainer = ({ spacing }: Theme) => css`
  padding: ${spacing(2.5)}px;
`;

export const list = ({ spacing }: Theme) => css`
  padding-bottom: ${spacing(25)}px;

  // Ensures that the second of two direct sibling dividers in a row is hidden
  & > [aria-hidden='true'] + [aria-hidden='true'] {
    display: none;
  }
`;

export const thinDivider = ({ spacing }: Theme) => css`
  margin-top: ${spacing(1.5)}px;
`;
